import { IMyHomeV2Schema } from '../../repositories/price-estimator/entities/card/MyHomeV2Schema';

export interface IMyHomeRealtyList {
  data?: IMyHomeV2Schema[];
  status: EMyHomeRealtyListStatus;
}

export interface IMyHomeState {
  realtyList: IMyHomeRealtyList;
}

export enum EMyHomeRealtyListStatus {
  init = 'init',
  loading = 'loading',
  succeed = 'succed',
  failed = 'failed',
}
